import CustomButton from "@/components/Buttons/CustomButton";
import cn from "classnames";
import {
  BG_VARIANTS,
  BORDER_VARIANTS,
  COLOR_VARIANTS,
  HOVER_BG_VARIANTS,
  HOVER_COLOR_VARIANTS,
} from "@/constants";

export default function PrimaryBtn({
  children,
  bgColor,
  color,
  className,
  ...props
}) {
  return (
    <CustomButton
      className={cn(
        bgColor && BG_VARIANTS[bgColor],
        color && COLOR_VARIANTS[color],
        color && HOVER_BG_VARIANTS[color],
        bgColor && HOVER_COLOR_VARIANTS[bgColor],
        color && BORDER_VARIANTS[color],
        color ? "border-2" : "border-0",
        "inline-block text-sm sm:text-base md:text-lg lg:text-xl transition-colors font-medium",
        className,
      )}
      {...props}
    >
      {children}
    </CustomButton>
  );
}
